import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import InspectionResultsFilter from './inspectionresults-filter';
import InspectionResultsTable from './inspectionresults-table';
import InspectionResultsTile from './inspectionresults-tile';
import InspectionResultsSearch from './inspectionresults-search';
import { selectInspectionResultsFilterVisible, selectTileView } from './store/selectors'; // Import the selector

const InspectionResultsContent = props => {
  const isFilterVisible = useSelector(selectInspectionResultsFilterVisible); // Use the selector
  const showTileView = useSelector(selectTileView); // Use the selector
  console.log('in inspection content ===>');
  return (
    <div className="card table-list-card">
      <div className="card-body">
        <div className="table-top">
          <InspectionResultsSearch />
        </div>
        {isFilterVisible && <InspectionResultsFilter />}

        {!showTileView ? <InspectionResultsTable /> : <InspectionResultsTile />}
      </div>
    </div>
  );
};

export default InspectionResultsContent;
